<div class="c-paragraph-meter o-ratio o-ratio--a4">
  <div class="c-paragraph-meter__body o-ratio__content"
       [ngStyle]="{ 'grid-template-rows': 'repeat(30, auto)' }">

    <ng-container *ngFor="let paragraph of paragraphs; let index = index">
      <div *ngFor="let line of (paragraph | splitLines); let last = last"
           class="c-paragraph-meter__line"
           [class.c-paragraph-meter__line--active]="index === activeIndex"
           [class.c-paragraph-meter__line--warn]="(paragraph | splitLines).length >= 8"
           [class.c-paragraph-meter__line--danger]="(paragraph | splitLines).length >= 10"
           [class.c-paragraph-meter__line--last]="last">

        <span class="c-paragraph-meter__line-progress"
              [style.width.%]="(line.length / 75) * 100">
        </span>
      </div>
    </ng-container>

  </div>
</div>
